export const ACCOUNT_USERINFO = 'ACCOUNT_USERINFO'
export const HOT_GOODS_WORD = 'HOT_GOODS_WORD'
export const HOT_BRAND_WORD = 'HOT_BRAND_WORD'
export const SHELVES_GOODS_COUNT = 'SHELVES_GOODS_COUNT'

// 修改isBill的值
// export const apple = 'apple';
export const CHANGE_IS_BILL = 'CHANGE_IS_BILL';
export const LOGO_URL = 'LOGO_URL';
export const HEADER_NAME = 'HEADER_NAME';
export const BACK_PICTURE = 'BACK_PICTURE';
export const BODY_ID = 'BODY_ID';





// WEBPACK FOOTER //
// ./src/store/mutations-type.js